"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  INITIALIZE_AUTH: null,
  INITIALIZE_CONFIG: null,
  PURCHASE_MOTION_DATA_REQUESTED: null,
  PURCHASE_MOTIONS_BY_LOCATION_RECEIVED: null,
  PURCHASE_MOTION_DATA_SUCCEEDED: null,
  PURCHASE_MOTION_DATA_FAILED: null,
  ELIGIBLE_PROMOTIONS_REQUESTED: null,
  ELIGIBLE_PROMOTIONS_RECEIVED: null,
  ELIGIBLE_PROMOTIONS_FAILED: null,
  ACTIVE_CURRENCY_CODE_UPDATED: null,
  ACTIVE_TERM_UPDATED: null,
  ACTIVE_TERM_RESET: null,
  COUNTRY_REQUESTED: null,
  COUNTRY_RECEIVED: null,
  COUNTRY_FAILED: null,
  SETTINGS_REQUESTED: null,
  SETTINGS_RECEIVED: null,
  SETTINGS_FAILED: null,
  MERCHANDISE_REQUESTED: null,
  MERCHANDISE_FAILED: null,
  MERCHANDISE_RECEIVED: null,
  CUSTOMER_CURRENCY_CODE_RECEIVED: null,
  SUBSCRIPTION_TERMS_RECEIVED: null,
  MERCHANDISE_IDS_TREATED_AS_OWNED_RECEIVED: null,
  AVAILABLE_TRIALS_RECEIVED: null,
  TRIAL_STATE_RECEIVED: null,
  PARCELS_RECEIVED: null,
  PURCHASED_PRODUCT_TERMS_RECEIVED: null,
  BILLING_TERMS_RECEIVED: null,
  BILLING_TERMS_FAILED: null,
  CONTACTS_IN_CRM_REQUESTED: null,
  CONTACTS_IN_CRM_RECEIVED: null,
  CONTACTS_IN_CRM_FAILED: null,
  MARKETING_CONTACTS_REQUESTED: null,
  MARKETING_CONTACTS_RECEIVED: null,
  MARKETING_CONTACTS_FAILED: null,
  MC_BETA_ELIGIBILITY_REQUESTED: null,
  MC_BETA_ELIGIBILITY_RECEIVED: null,
  MC_BETA_ELIGIBILITY_FAILED: null,
  REQUIRED_ONBOARDING_REQUESTED: null,
  REQUIRED_ONBOARDING_RECEIVED: null,
  REQUIRED_ONBOARDING_FAILED: null,
  ACTIVE_HUB_UPDATED: null,
  PUBLIC_MERCH_CATALOG_REQUESTED: null,
  PUBLIC_MERCH_CATALOG_FAILED: null,
  USERS_IN_PORTAL_REQUESTED: null,
  USERS_IN_PORTAL_RECEIVED: null,
  USERS_IN_PORTAL_FAILED: null,
  PHONE_NUMBERS_RECEIVED: null,
  PUBLIC_META_DATA_REQUESTED: null,
  PUBLIC_META_DATA_RECEIVED: null,
  PUBLIC_META_DATA_FAILED: null,
  EXPERIMENT_TREATMENTS_REQUESTED: null,
  EXPERIMENT_TREATMENTS_RECEIVED: null,
  EXPERIMENT_TREATMENTS_FAILED: null,
  PUBLIC_FEATURE_FLAGS_RECEIVED: null,
  WP006_SIMPLIFY_TABS_REQUESTED: null,
  COVID_SUITE_PROMO_ELIGIBILITY_REQUESTED: null,
  COVID_SUITE_PROMO_ELIGIBILITY_RECEIVED: null,
  COVID_SUITE_PROMO_ELIGIBILITY_FAILED: null
});

exports.default = _default;
module.exports = exports.default;